import * as React from "react";
import type { SVGProps } from "react";
const SvgKbc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#0097db"
      d="M20 6H4c-1.105 0-2 .908-2 2.028v8.944C2 18.092 2.895 19 4 19h16c1.105 0 2-.908 2-2.028V8.028C22 6.908 21.105 6 20 6"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M12.05 11.503c1.012 0 1.832-.858 1.832-1.918s-.82-1.918-1.831-1.918-1.831.859-1.831 1.918c0 1.06.82 1.918 1.83 1.918"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M11.648 11.93c-.612 0-1.14-.25-1.475-.527a40 40 0 0 0-3.485.531v.816h10.625v-1.717s-1.838-.012-3.911.104a2.36 2.36 0 0 1-1.754.793m-3.701 4.403h-1.26v-3.071h1.26v1.382l.749-1.382h1.51L9.1 14.849l1.044 1.484H8.703l-.747-1.154zm9.346-.163a3.4 3.4 0 0 1-1.038.163c-1.246 0-2.161-.4-2.161-1.563 0-1.051.886-1.508 2.099-1.508.337 0 .765.042 1.1.163l-.001 1.018a1.4 1.4 0 0 0-.852-.275c-.462 0-.924.257-.924.63 0 .374.46.63.925.63.35 0 .603-.11.851-.271zm-5.62-1.606h.627c.242 0 .337-.115.337-.292 0-.202-.096-.303-.32-.303h-.645zm0 1.145h.656c.246 0 .33-.12.33-.296s-.084-.303-.327-.303h-.66zm-1.26-2.447h2.546c.662 0 .879.301.879.77 0 .525-.401.753-.812.778v.01c.422.038.834.094.834.713 0 .405-.217.8-.945.8h-2.502z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgKbc;
